const header = () => {
  
  var menuEl = $(".header-main");
  var accountMenuEl = $(".my-account-mobile-mnu-wrapper").find('.my-account-menu-mobile');
  var accountStickyOffsetMenu = accountMenuEl.hasClass('my-account-menu-mobile') ? accountMenuEl.offset().top: 0;
  var stickyOffsetMenu = menuEl.offset().top || 0;
  var getProductSample = [];
  var jqxhr;
  
  if(productSample && productSample.length > 0){
    getProductSample = productSample
  }
  var badge       = $('.cart-badge-custom'); 
  var shoppingCart= $('#shopping-cart'); 
  var moneyFormat = $('.navbar-activities-tab').data('format-money')
  var formData    = [];
  var productSamplePreventClick = 0;
  var utf8_to_b64 = ( str ) => {
    return window.btoa(unescape(encodeURIComponent( str )));
  }
  var removeCookie = () =>  {
    const regex = /identity-state-.*/g;
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        const found = name.match(regex);
        if(found && found.length > 0){
          document.cookie = name + "=;path=/";
        }
    }
  }
  // Remove cookies login with customer
  removeCookie();

  var refreshAppendDom = () => {
    var wrapperAcceptButton = $(".cc-compliance");
    var acceptCookieLink = $(".cc-message").find(".cc-link");
    var elCloseButton = '<a aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-btn cc-dismiss">Close</a>';

    if(wrapperAcceptButton.hasClass("cc-compliance")){
      wrapperAcceptButton.append(elCloseButton);
      acceptCookieLink.attr('target', '_self');
    } else {
      setTimeout(() => refreshAppendDom(), 500);
    }
  };

  refreshAppendDom(); 

  // Function
  var formatMoney = (cents, format) => {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format ||  moneyFormat);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
        case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
        case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
        case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
  // clear timer interval 
  var clearTimerInterval = () => {
    let checkoutProductWrapper =  $('.checkout-products');
    clearInterval(startCountDown);
    let products = $('.list-products ul > li'); 
    // Hide timer when no product in cart
    if(products.length<=0) {
      checkoutProductWrapper.find('.basket-wrapper').hide();
      checkoutProductWrapper.find('.basket-wrapper .basket-count-timer').text('');
    }
    document.cookie = countDownCookieName+"=;path=/;";
  }
  // Manage data in form
  var manageData = (variantId,num) => {
    if(formData.length > 0){
      let findExistVariant = formData.find(r => r.variant_id == variantId);
      if(findExistVariant){
        formData.map(r => {
          if(r.variant_id===variantId) r.quantity = num;
          return r;
        })
      }else{
        formData.push({variant_id:variantId,quantity:num})
      }
    }else{ 
      formData.push({variant_id:variantId,quantity:num})
    }
    formData = formData.filter(r => r.variant_id != undefined && r.variant_id) 
  }


  // Generate subtotal page
  var generateSubtotal = () => {
    let products = $('.list-products ul > li');
    let data = [];
    let sumSubTotal = 0 ;
    let reg = /(\d+(?:\.\d+)?)/
    console.log(products);
    $.each(products,function(index,product){
      let findPrice = $(this).find('.price').text().match(reg);
      let price = 0;
      if(findPrice && findPrice.length > 0){
        price = findPrice[0]
      }
      data.push(
        {
          variant_id: $(this).data('variant-id'),
          price: parseFloat(price),
          quantity: parseInt($(this).find('.input-qty input[type="number"]').val())
        }
      )
    })
    data.map(r => {
      sumSubTotal += r.price * r.quantity;
    }) 
    $('.checkout-products .total-price').text(`$${sumSubTotal.toFixed(2)}`);

    let finalData = [];
    data.map(r => {
      finalData.push(`updates[${r.variant_id}]=${r.quantity}`);
    }) 
    
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: finalData.join('&'),
      dataType: "json",
      beforeSend: function(){
        $('#content-shopping-card .spinner-border').show();
      },
      success: function(r){
        $('#content-shopping-card .spinner-border').hide();
        document.documentElement.dispatchEvent(new CustomEvent('cart:badge-refresh', {
          bubbles: true
        }));
      }
    })
    .catch(error => {
      $('#content-shopping-card .spinner-border').hide();
    })
  }

  // Get sampler product list
  // var getSampleProducts = (self,items=[]) => {
  //   let variantId = self.data('variant-id');
  //   self.parents('.product-sample').find('.spinner-border').show();
  //   let findExistVariant = items.find(v => v.variant_id == variantId)
  //   if(findExistVariant) return
  //   let formData = {
  //     'items': [{
  //     'id': variantId,
  //     'quantity': 1
  //     }]
  //   };
  //   let sampleProducts = fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //       'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(formData)
  //     })
  //     .then(response => {
  //       return response.json();
  //     })
  //     .catch((error) => {
  //       console.error('Error:', error);
  //     });
  //   sampleProducts.then(r => {
  //     productSamplePreventClick = 0
  //     self.parents('.product-sample').find('.spinner-border').hide();
  //     $('.product-sample').remove();
  //     let li = '';
  //     let productList = $('.list-products');
  //     if(r.items.length > 0) {
  //       let item = r.items[0];
  //       let fPrice = item.discounted_price > 0 ? (item.final_price - item.discounted_price) : item.final_price ;
  //       let finalPrice = formatMoney(fPrice,moneyFormat);
  //       if(fPrice<=0) finalPrice = 'FREE';
  //       li = `<li data-id="${item.id}" data-variant-id="${item.variant_id}">
  //               <div class="product-img pd-inside">
  //                 <img src="${item.image}" alt="${item.title}">
  //               </div>
  //               <div class="product-info pd-inside">
  //                 <div class="sample-title">Sampler</div>
  //                 <div class="product-name">${item.title}</div>
  //                 <div class="price"><span>${finalPrice}</span></div>
  //               </div>
  //               <div class="product-amount pd-inside text-center position-relative">
  //                   <div class="input-qty">
  //                       <input readonly class="count" type="number" min="1" value="${item.quantity}" />
  //                   </div>
  //               </div>
  //               <div class="product-remove pd-inside">
  //                 <div class="btn-remove">
  //                     <span class="icon-delete"></span> Remove
  //                 </div>
  //               </div>
  //             </li>`;
  //       productList.find('ul').append(li)
  //       document.documentElement.dispatchEvent(new CustomEvent('cart:badge-refresh', {
  //         bubbles: true
  //       }));
  //     }
  //   })
  //   .catch(error => {
  //     productSamplePreventClick = 0
  //     self.parents('.product-sample').find('.spinner-border').show();
  //   })
  // }
  // var removeCheckoutButton = () => {
  //   $('.checkout-products .checkout-point button.go-to-checkout').remove();
  // }
  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  var  onHeaderScroll = () => {
    // Get the header
    let header   = document.querySelector(".my-account-mobile-mnu-wrapper");
    let banner   = document.querySelector(".banner-text");
    let orderElm = $('.my-order')
    // Get the offset height of the navbar
    if(!header || !banner) return;
    
    console.log(accountStickyOffsetMenu);
    if ($(window).scrollTop() >= (accountStickyOffsetMenu)) {
      header.classList.add("stick-header-2");
      if($(header).is(':visible')) orderElm.attr('style','margin-top:128px !important;')
    } else {
      header.classList.remove("stick-header-2");
      orderElm.removeAttr('style');
    }
  }

  // Add the sticky class to the header when you reach its scroll position. Remove "Fixed" when you leave the scroll position
  var  onProductScroll = () => {
    // Get the header
    let header = document.querySelector(".sub-menu-wrapper");
    // Get the offset height of the navbar
    if(!header) return;

    stickyOffsetMenu = document.querySelector("header").offsetHeight - 60;//window.enable_sticky ? 0 : stickyOffsetMenu; 
    if ($(window).scrollTop() >= (stickyOffsetMenu)) {
      header.classList.add("stick-header");
    }
    if(window.pageYOffset<=0) header.classList.remove("stick-header");
  }
  onProductScroll();

  // Show cart auto when user add to bag
  var showCart = () => {
    $(".selected").removeClass("selected");//remove selected tabs
    badge.addClass('d-none');
    $('.tab-show-activities').find('> div').hide();
    try {
      if (Rebuy.SmartCart !== undefined) {
        $('#shopping-cart2').find('a.nav-link').addClass('selected');
        Rebuy.SmartCart.show();
      } else {
        $('#shopping-cart').find('a.nav-link').addClass('selected');
        $('#tab-shopping-cart').show();  
        $('.tab-show-activities').addClass('tab-show');
        $('body').addClass('show-checkout');
        document.body.style.overflow = 'hidden';
      }
    } catch (e) {
      $('#tab-shopping-cart').show();
      $('.tab-show-activities').addClass('tab-show');
      $('body').addClass('show-checkout');
      document.body.style.overflow = 'hidden';
    }
    
  }
  //  Navbar Tab Menu
  $(document).on('click','.navbar-activities-tab li > a:not(.user-login, .rebuy, .open-search, .close-search)',function (e) {
    e.preventDefault(); 
    if($(this).attr('is-customer-login') == 1) return
    var name = $(this).parent("li").attr("id");
    if($(this).hasClass('selected')){
      $('.login-custom-alert').addClass('d-none');
      $('body').removeClass('show-checkout');
      if(parseInt(badge.text()) > 0 ){
        badge.removeClass('d-none').show();
        shoppingCart.removeClass('has-button');
      }else{
        badge.addClass('d-none').hide();
        shoppingCart.addClass('has-button');
      }
      if (name != 'shopping-cart') {
        toggleClickMenu(name);
      } else {
        try {
          Rebuy.SmartCart.hide();
        } catch (e) {
          toggleClickMenu(name);
        }
      }
    }else{
      $(this).parents("ul").find(' li a').removeClass('selected')
      var dbClick = $(this).attr("class").includes("selected");
      if ("shopping-cart" == name) {
        badge.addClass('d-none').hide();
      }else{
        if(parseInt(badge.text()) > 0 ){
          badge.removeClass('d-none').show();
          shoppingCart.removeClass('has-button');
        }else{
          badge.addClass('d-none').hide();
          shoppingCart.addClass('has-button');
        }
      }
      if (!dbClick) {
        $(".selected").removeClass("selected"); // removes the selected class
        $(this).addClass("selected"); // adds the selected class to current clicked elem
        if (name != 'shopping-cart') {
          $("#tab-" + name)
          .show()
          .siblings("div")
          .hide(); // shows the target and hides other
          try {
            Rebuy.SmartCart.hide();
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            Rebuy.SmartCart.show();
            $("#tab-" + name)
            .siblings("div")
            .hide(); // shows the target and hides other
          } catch (e) {
            $("#tab-" + name)
            .show()
            .siblings("div")
            .hide(); // shows the target and hides other
          }
        }
        $("body").css("overflow", "hidden");
        $(".tab-show-activities").addClass("tab-show");
      } else {
        toggleClickMenu(name);
      }
    }
  });

  $(document).on('click','.navbar-activities-tab li > a.open-search',function (e) {
    e.preventDefault(); 
    $(this).hide();
    $(this).parents("ul").find(' li a').removeClass('selected')
    $('.navbar-activities-tab li > a.close-search').show();
    $("#tab-search")
    .show()
    .siblings("div")
    .hide(); // shows the target and hides other
    $("body").css("overflow", "hidden");
    $(".tab-show-activities").addClass("tab-show");
    $("body, header.content-header").removeClass('scroll-down').addClass("scroll-up");
    try {
      Rebuy.SmartCart.hide();
    } catch (e) {
      console.log(e);
    }
  });
  $(document).on('click','.navbar-activities-tab li > a.close-search',function (e) {
    e.preventDefault(); 
    var name = $(this).parent("li").attr("id");
    $(this).hide();
    $(this).parents("ul").find(' li a').removeClass('selected')
    $('.navbar-activities-tab li > a.open-search').show();
    $("#tab-search")
    .hide()
    .siblings("div")
    .hide();
    $(".tab-show-activities").removeClass("tab-show");
    $("body").css("overflow", "auto");
    try {
      Rebuy.SmartCart.hide();
    } catch (e) {
      console.log(e);
    }
  });


  function toggleClickMenu(name){
    $(".selected").removeClass("selected"); // hide selected if double click icons
      $("#tab-" + name)
        .hide()
        .siblings("div")
        .hide(); // hide tab if double click icons
      $(".tab-show-activities").removeClass("tab-show");
      $("body").css("overflow", "auto");
  }

  // End header fix scroll
  $(document).on('keyup','.input-qty input[type="number"]',function() { 
    if($(this).val()=='') {
      $(this).val(1);
    } else if($(this).val() > 5) {
      $(this).val(5);
    }
    // generateSubtotal();
  });

  // Plus update quantity
  $(document).on('click','.add',function() { 
      let root      = $(this);
      let num       = +root.parents('.input-qty').find('input.count').val() + 1;
      let parent    = root.parents('li');
      let variantId = parent.data('variant-id');
      let max_qtdy  = root.parents('.input-qty').find('input.count').attr('max');
      
      if (num>max_qtdy) num = max_qtdy

      root.parents('.input-qty').find('input.count').val(num); 
      // manageData(variantId,num);
      // generateSubtotal();
  }); 

  // Substract update quantity
  $(document).on('click','.sub', function() {
    
    let root      = $(this);
    let parent    = root.parents('li');
    let variantId = parent.data('variant-id');
    let num       = +root.parents('.input-qty').find('input.count').val()
    if(num > 1) { 
      num = num - 1;
      root.parents('.input-qty').find('input.count').val(num)
      // manageData(variantId,num)
      // generateSubtotal()
    }
  });

  // Click on checkout button get data from manageData
  $(document).on('click','.checkout-point button.go-to-checkout',function(e) {
    let finalData = [];
    formData.map(r => {
      finalData.push(`updates[${r.variant_id}]=${r.quantity}`);
    }) 
    if(finalData.length<=0) window.open(window.location.origin + '/checkout', '_self');
    $(this).css('background-color','#bbb').prop('disabled', true).find('span.spinner-border').show();
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: finalData.join('&'),
      dataType: "json",
      beforeSend: function(){
        $('.spinner-border').show();
      },
      success: function(r){
        window.open(window.location.origin + '/checkout', '_self');
        $(this).prop('disabled', false)
        $(this).removeAttr('style').find('span.spinner-border').hide();
      }
    })
    .catch(error => {
      $(this).prop('disabled', false)
      $(this).removeAttr('style').find('span.spinner-border').hide();
    })
  })


  // check if the input has any value (if we've typed into it)
  $("input").blur(function () {
    if ($(this).val()) $(this).addClass("used");
    else $(this).removeClass("used");
  });

  // All Form action in header
  // $("#form-login").validate();
  // $("#form-create-account").validate();
  // $("#form-login-mobile").validate();
  // $("#form-create-account-mobile").validate();
  $("#form-forget-password").validate({
    submitHandler: function () {
      $("#form-forget-password .success-message-submit").show();
    },
  });

  $("#form-forget-password-mobile").validate({
    submitHandler: function () {
      $("#form-forget-password-mobile .success-message-submit").show();
    },
  });

  // Switch form login and forget on tab user action
  $(document).on('click','a[action-to-forget]', function(){
    var loginForm = $(".login-form");
    var forgetPasswordForm = $(".forget-password-form");
    loginForm.hide();
    forgetPasswordForm.show();
  })

  $(document).on('click','a[action-to-login]', function(){
    var loginForm = $(".login-form");
    var forgetPasswordForm = $(".forget-password-form");
    loginForm.show();
    forgetPasswordForm.hide();
    $("#form-forget-password .success-message-submit").hide();
    $("#form-forget-password-mobile .success-message-submit").hide();
  })

  if (window.location.hash == "#recover") {
    loginForm.hide();
    forgetPasswordForm.show();
  } 

  // only refresh bubble

  // Only listen update cart quantity
  document.addEventListener('cart:badge-refresh', e => {
    let cartContents = fetch('/cart.js').then(response => response.json()).then(data => { return data });
    cartContents.then(r => {
      formData = r.items
      if(r.item_count==0){
        badge.addClass('d-none');
        shoppingCart.addClass('has-button');
        $('.checkout-products .checkout-point button.go-to-checkout').prop('disabled', true)
        clearTimerInterval();
      }else{
        badge.removeClass('d-none').show();
        shoppingCart.removeClass('has-button');
        $('.checkout-products .checkout-point button.go-to-checkout').prop('disabled', false)
      }
      if(badge.parents('a').hasClass('selected')) badge.addClass('d-none'); 
      badge.text(r.item_count)

      // $.get('/?sections=cart-template-custom').then(sections => {
      //   if(sections['cart-template-custom']){
      //     $('#content-shopping-card').remove();
      //     $('#tab-shopping-cart').html(sections['cart-template-custom']);
      //   }
      // });
    });
  });

  // List every update on cart 
  document.addEventListener('cart:refresh', e => {
    if(startCountDown) clearTimerInterval();
    if(typeof e.detail != undefined && e.detail) manageData(e.detail.variant_id,e.detail.qty);
    let cartContents = fetch('/cart.js').then(response => response.json()).then(data => { return data });
    cartContents.then( r => {
      formData = r.items
      if(r.item_count==0){
        badge.addClass('d-none');
        shoppingCart.addClass('has-button');
        $('.checkout-products .checkout-point button.go-to-checkout').prop('disabled', true)
        clearTimerInterval();
      }else{
        badge.removeClass('d-none').show();
        shoppingCart.removeClass('has-button');
        $('.checkout-products .checkout-point button.go-to-checkout').prop('disabled', false)
      }

      // if(r.item_count > 0) {
      //   document.documentElement.dispatchEvent(new CustomEvent('cart:startCountDown', {
      //     bubbles: true
      //   }));
      // }

      badge.text(r.item_count)
      
      $.get('/?sections=cart-template-custom').then(sections => {
        if(sections['cart-template-custom']){
          $('#content-shopping-card').remove();
          $('#tab-shopping-cart').html(sections['cart-template-custom']);
        }
        showCart();
      });
    });
  });
  
  // Click on slick of sample collection
  // $(document).on('click','.carousel-product .slick-list .slick-slide',function() {
  //   if(productSamplePreventClick > 0) return;
  //   productSamplePreventClick++
  //   let cartContents =  fetch('/cart.js')
  //     .then(response => response.json())
  //     .then(data => { return data });
  //     cartContents.then(r => {
  //       getSampleProducts($(this),r.items);
  //     })
  // })

  // When the user scrolls the page, execute onHeaderScroll
  window.onscroll = function() { 
    onHeaderScroll()
    onProductScroll()
  };
 
  $('#cancellPurchase').on('shown.bs.modal', function (event) {
    let button = $(event.relatedTarget) // Button that triggered the modal
    let orderId = button.data('order-id')
    let modal = $(this) 
        modal.find('input[name="order-id"]').val(orderId)
  })

  $('#cancellPurchase').on('hidden.bs.modal', function (event) {
    $('input[name="order-id"]').val('')
    $('.modal-cancel-purchase-body-textarea').val('');
  })
  // If no product list and not in checkout page clear interval
  if($('.list-products ul > li').length<=0 && currentTemplate!='checkout') {
    clearTimerInterval();
  }
   

  //REBUY
  document.addEventListener('rebuy:smartcart.hide', function(event){ 
    
  }); 


  $(function () {
    const body = document.body;
    const header = document.querySelector("header");
    const main = document.querySelector("main");
    const headerHeight = document.querySelector("header").offsetHeight;

    main.style.top = (headerHeight -1) + "px";

    let lastScroll = 0;

    window.addEventListener("scroll", () => {
      if($('body').css('overflow') != 'hidden') {
        let currentScroll = window.scrollY;
        if (currentScroll - lastScroll > 0 && window.scrollY > headerHeight) {
          // scrolled down -- header hide
          header.classList.add("scroll-down");
          header.classList.remove("scroll-up");
          body.classList.add('scroll-down')
          body.classList.remove("scroll-up");
        } else {
          // scrolled up -- header show
          header.classList.add("scroll-up");
          header.classList.remove("scroll-down");
          body.classList.add('scroll-up')
          body.classList.remove("scroll-down");
        }
        lastScroll = currentScroll;
      }
    })
  });


};

export default header;